import { Pipe, PipeTransform } from '@angular/core'

import { UtilityService } from '@core/services/utility.service'
import { dateFormats } from '@core/constants/dateFormats'
import { AuthService } from '@app/modules/auth/auth.service'

@Pipe({
  name: 'dayjsDateFullTimePipe',
  standalone: false,
})
export class DayjsDateFullTimePipe implements PipeTransform {
  constructor(
    private utilityService: UtilityService,
    private readonly authService: AuthService,
  ) {}

  transform(date?: string): string {
    const dateFormat = `${this.authService.getCurrentUserDateFormat()} HH:mm:ss` || dateFormats.dateTimeFull

    return this.utilityService.dayjsDateTimeFormatting(date, dateFormat)
  }
}
